import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { useTitle } from '@/composables/ui/useTitle'
import { useColorScheme } from '@/composables/ui/useColorScheme'
import { computed } from 'vue'
import PageLoader from '@/components/common/PageLoader.vue'
import PWAInstallPrompt from '@/components/PWAInstallPrompt.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Douglas Private Care Services')
useTitle(appTitle.value)

useColorScheme()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageLoader),
    _createVNode(_component_router_view),
    _createVNode(PWAInstallPrompt)
  ]))
}
}

})